import { configuration } from "../api/client/SdsWebApiClient";

/** Matches SdsProductLogic.Encoding.SdsConfigEncodings.DEFAULT */
export const DEFAULT_CONFIG_ENC_TYPE = "default";

export interface BuildStatelessConfigImageUrlOptions {
    scaledHeight: number;
    ext?: string;
    allowUpscaling?: boolean;
    accountId?: string | null;
    market?: string | null;
}

/**
 * Builds a GET URL for the stateless `get_image_from_encoded_string` API (same contract as
 * SummaryUrlGenerator / OpenAPI). Use for `<img src>`, QR codes, or any direct browser load.
 */
export function buildStatelessConfigImageUrl(
    encodedConfig: string,
    options: BuildStatelessConfigImageUrlOptions,
    basePath: string = configuration.basePath
): string {
    const params = new URLSearchParams();
    params.set("enc_type", DEFAULT_CONFIG_ENC_TYPE);
    params.set("encoded_config", encodedConfig);
    params.set("scaled_height", String(options.scaledHeight));
    if (options.ext !== undefined) {
        params.set("ext", options.ext);
    }
    if (options.allowUpscaling !== undefined) {
        params.set("allow_upscaling", String(options.allowUpscaling));
    }
    if (options.accountId) {
        params.set("account_id", options.accountId);
    }
    if (options.market) {
        params.set("market", options.market);
    }

    const root = basePath.replace(/\/+$/, "");
    return `${root}/api/get_image_from_encoded_string?${params.toString()}`;
}
